const axios = require("axios");
export const DASH_URL = "https://dashboard.notifica.re/api/v2";
export const API_URL = "https://push.notifica.re";

export const createDemo = data =>
    axios({
        method: "post",
        url: `${DASH_URL}/accounts/trial`,
        data,
        headers: { "Content-Type": "application/json" }
    });

export const createEmailContact = data =>
    axios({
        method: "post",
        url: `${API_URL}/email/subscribe`,
        data,
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Basic " + btoa(`b3076f1c7ebd24ff283888ffe317e72a92a8e85516bed29f4f8d3e6eb8a65f83:cb3e338f219b251afeb10e80588a9095247e7b008cdd765e8dcdd17de4aabc9a`)
        }
    });

export const createSMSContact = data =>
  axios({
    method: "post",
    url: `${API_URL}/sms/subscribe`,
    data,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Basic " + btoa(`b3076f1c7ebd24ff283888ffe317e72a92a8e85516bed29f4f8d3e6eb8a65f83:cb3e338f219b251afeb10e80588a9095247e7b008cdd765e8dcdd17de4aabc9a`)
    }
  });

export const loadForm = (type) =>
    axios({
        method: "get",
        url: `${DASH_URL}/forms/` + type
    });


export const submitForm = (type, data) =>
    axios({
        method: "post",
        url: `${DASH_URL}/forms/` + type,
        data,
        headers: { "Content-Type": "application/json" }
    });

export const createAccount = (data) =>
    axios({
        method: "post",
        url: `${DASH_URL}/accounts`,
        data,
        headers: { "Content-Type": "application/json" }
    });

export const checkPassword = (data) =>
    axios({
        method: "put",
        url: `${DASH_URL}/accounts/checkpassword`,
        data,
        headers: { "Content-Type": "application/json" }
    });


export const fetchSMSPricing = (country) =>
    axios({
        method: "get",
        url: `${DASH_URL}/sms/info/pricing/` + country
    });

export const listCountries = () =>
    axios({
        method: "get",
        url: `${DASH_URL}/geo/country`
    });
